import { RouteConfig } from 'vue-router';
import { TrackedPage } from '@/_core/tracking/trackedpages';
const env = process.env.NODE_ENV;

const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'home',
        meta: {
            pageVisiteEvent: TrackedPage.UserDashboard,
        },
        component: () => import(/* webpackChunkName: "home" */ '../pages/root/dashboard/Dashboard.vue'),
    },
    {
        path: '/corporatesubscriptionmanagement',
        component: () =>
            import(
                /* webpackChunkName: "corporateSubscriptionManagement" */ '@/pages/components/corporateSubscription/corporateSubscription.vue'
            ),
        name: 'corporateSubscriptionManagement',
        beforeEnter: (to, from, next) => {
            if (initAppData.isCorporateSubscriptionManager) {
                next();
            } else {
                next('/');
            }
        },
    },
    {
        path: '/newworkspace',
        name: 'newworkspace',
        meta: {
            pageVisiteEvent: TrackedPage.NewWorkspace,
        },
        component: () => import(/* webpackChunkName: "newworkspace" */ '../pages/root/newWorkspace/NewWorkspace.vue'),
    },
    {
        path: '/domaincontrol/accounts',
        name: 'domaincontrolAccounts',
        meta: {
            pageVisiteEvent: TrackedPage.ControlledDomainAccounts,
        },
        props: (route) => ({ domain: route.query.domain }),
        component: () => import(/* webpackChunkName: "domaincontrolAccounts" */ '../pages/root/domaincontrol/accounts/Accounts.vue'),
    },
    {
        path: '/domaincontrol',
        name: 'domaincontrol',
        meta: {
            pageVisiteEvent: TrackedPage.DomainControl,
        },
        component: () => import(/* webpackChunkName: "domaincontrol" */ '../pages/root/domaincontrol/DomainControl.vue'),
    },
];

if (env === 'development') {
    routes.push({
        path: '/devicons',
        name: 'devicons',
        component: () => import(/* webpackChunkName: "devicons" */ '../pages/dev/DevIcons.vue'),
    });
}

export { routes };
